module.exports = __webpack_public_path__ + "static/media/debi.f207c6cd.jpg";